import Splide from '@splidejs/splide';

export default {

	init() {
		console.log('init sliders...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	// Set up all standard sliders
	bindEvents() {	
		var elems = document.querySelectorAll('.splide.slider:not([data-splide-ignore])');

		if (elems.length) {
			elems.forEach(function (elem) {
				let slider = new Splide(elem, {
					type: 'loop',
					perPage: elem.classList.contains('slider-mini') ? 3 : 1,
					autoWidth: true,
					arrows: true,
					pagination: true,
					trimSpace: false,
					arrowPath: 'm14.2928932 10.2928932c.3905243-.39052427 1.0236893-.39052427 1.4142136 0l9 9 .7071068.7071068-9.7071068 9.7071068c-.3905243.3905243-1.0236893.3905243-1.4142136 0s-.3905243-1.0236893 0-1.4142136l8.2921068-8.2928932-8.2921068-8.2928932c-.3604839-.360484-.3882135-.927715-.0831886-1.3200062z',
					classes: {
						arrows: 'splide__arrows',
						arrow: 'splide__arrow btn-round',
						prev: 'splide__arrow--prev',
						next: 'splide__arrow--next',
						pagination: 'splide__pagination', // container
						page: 'splide__pagination__page', // each button
					},
					breakpoints: {
						640: {
							perPage: 1,
						}
					},
				}).mount();

				slider.on('move', function() {
					Sliders.toggleClass(elem, true);
					Video.stopAllVideos();
				});

				slider.on('moved', function() {
					Sliders.toggleClass(elem, false);
				});

				slider.on('drag', function() {
					Sliders.toggleClass(elem, true);
				});

				slider.on('dragged', function() {
					Sliders.toggleClass(elem, false);
				});

				Sliders.disableBreadcrumb(elem);
			});
		}
	},

	// Set up slider with thumbs
	initGallery(sliderId, thumbsId) {
		let slider = new Splide('#'+sliderId, {
			type: 'loop',
			perPage: 1,
			autoWidth: true,
			arrows: true,
			pagination: false,
			trimSpace: false,
			arrowPath: 'm14.2928932 10.2928932c.3905243-.39052427 1.0236893-.39052427 1.4142136 0l9 9 .7071068.7071068-9.7071068 9.7071068c-.3905243.3905243-1.0236893.3905243-1.4142136 0s-.3905243-1.0236893 0-1.4142136l8.2921068-8.2928932-8.2921068-8.2928932c-.3604839-.360484-.3882135-.927715-.0831886-1.3200062z',
			classes: {
				arrows: 'test splide__arrows',
				arrow: 'splide__arrow btn-round',
				prev: 'splide__arrow--prev',
				next: 'splide__arrow--next',
				pagination: 'splide__pagination', // container
				page: 'splide__pagination__page', // each button
			}
		});

		let thumbs = new Splide('#'+thumbsId, {
			type: 'slide',
			perPage: 1,
			autoWidth: true,
			rewide: true,
			arrows: false,
			pagination: false,
			isNavigation: true,
		});

		slider.sync(thumbs);
		slider.mount();
		thumbs.mount();

		slider.on('move', function() {
			Video.stopAllVideos();
		});

		// Store the splide reference
		$('#'+sliderId).data('slider', slider);
	},

	// Classname helper
	toggleClass(elem, isMoving) {
		if(isMoving) {
			elem.classList.remove('is-settled');
			elem.classList.add('is-moving');
		} else {
			elem.classList.remove('is-moving');
			elem.classList.add('is-settled');
		}
	},

	// Disable breadcrumb
	disableBreadcrumb(elem) {
		if(!elem.classList.contains('slider-hero')) {
			return;
		}

		var $slider  = $(elem);
		var $parent = $slider.parents('.bn-block-wrapper');
		var $breadcrumb = $parent.prev('.bn-block-wrapper.breadcrumb');
		
		if($breadcrumb.length) {
			$breadcrumb.addClass('hidden');
		}
	}

};